import { mockBuildFeatures } from '@domgen/dgx-fe-config';
import { AppBuildFeatures } from '../../models/build/app-build-features.type';

export const mockAppBuildFeatures: AppBuildFeatures = {
  ...mockBuildFeatures,
};
